import { instance } from "libs/api";

import { ApiRoutesSupport } from "../../constants/enums";
import { InAppConversationsListResponse } from "../../support.types";
import { GetConversationsParams } from "./getConversations.types";

export const requestGetConversations = async (
  params: GetConversationsParams
): Promise<InAppConversationsListResponse> => {
  return await instance.get(ApiRoutesSupport.Conversations, { params });
};
